<template>
  <HomeSection1></HomeSection1>
  <HomeSection2></HomeSection2>
  <HomeSection3></HomeSection3>
  <ConsultSection></ConsultSection>
  <HomeSection5></HomeSection5>
  <HomeSection6></HomeSection6>
  <HomeSection7></HomeSection7>
  <HomeSection8></HomeSection8>
</template>

<script>
import { onMounted, inject } from 'vue';
import HomeSection1 from './HomeSection1.vue';
import HomeSection2 from './HomeSection2.vue';
import HomeSection3 from './HomeSection3.vue';
import ConsultSection from './ConsultSection.vue';
import HomeSection5 from './HomeSection5.vue';
import HomeSection6 from './HomeSection6.vue';
import HomeSection7 from './HomeSection7.vue';
import HomeSection8 from './HomeSection8.vue';

export default {
  name: "OnclickHome",
  components: {
    HomeSection1,
    HomeSection2,
    HomeSection3,
    ConsultSection,
    HomeSection5,
    HomeSection6,
    HomeSection7,
    HomeSection8,
  },
  setup() {
    const updateMetaTag = inject('updateMetaTag');
    const updateOGTag = inject('updateOGTag');
    const updateCanonicalLink = inject('updateCanonicalLink');

    onMounted (() => {
        updateMetaTag('title', 'آن کلیک؛ سرویس تبلیغات آنلاین (ویدیویی، بنری و همسان)');
        updateMetaTag('description', 'آن کلیک، پلتفرم رسمی تبلیغات در فیلو است که انواع خدمات تبلیغات ویدیویی، تبلیغات بنری و همسان را با بودجه کاملا مناسب به شما ارائه می دهد.');
        updateOGTag('title', 'آن کلیک؛ سرویس تبلیغات آنلاین (ویدیویی، بنری و همسان)');
        updateOGTag('description', 'آن کلیک، پلتفرم رسمی تبلیغات در فیلو است که انواع خدمات تبلیغات ویدیویی، تبلیغات بنری و همسان را با بودجه کاملا مناسب به شما ارائه می دهد.');
        updateOGTag('url', 'https://onclick.ir/');
        updateOGTag('type', 'website');
        updateOGTag('image', require('@/assets/images/onclick.png'));
        updateCanonicalLink('https://onclick.ir');
    });

    return {};
  },
};
</script>

<style scoped>
</style>
